import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  assetDataService,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
  userService,
  praDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import editAssetDialog from '../dialog.editAssetDialog';
import editRiskDialog from '../../riskAdministration/dialog.editRiskDialog';
import controller from './asset.controller';
import directive from './asset.directive';
import deleteAssetConfirmDialog from '../dialog.deleteAssetConfirmDialog';
import syncAssetConfirmDialog from '../dialog.syncAssetConfirmDialog';
import copyAssetDialog from '../dialog.copyAssetDialog';

const assetModule = angular
  .module('app.components.admin.asset', [
    alerts,
    actionIcon,
    confirmDialog,
    editAssetDialog,
    editRiskDialog,
    loaderService,
    ssDialogService,
    assetDataService,
    riskDataService,
    assetSharedModelService,
    riskSharedModelService,
    userService,
    deleteAssetConfirmDialog,
    praDataService,
    syncAssetConfirmDialog,
    copyAssetDialog,
  ])
  .directive('asset', directive)
  .controller('AssetController', controller);

export default assetModule.name;

console.log('app.components.admin.asset created');
